// This file is AUTOGENERATED, do not edit it manually!!!

export const menu = {
    access_levels: 'Уровни доступа',
    activityList: 'Центр управления',
    addlicenses: 'Добавить лицензии',
    approvals: 'Запросы на согласование',
    archive: 'Архив',
    billingReport: 'Биллинг-отчет',
    builder: 'Конструктор',
    companySettings: 'Настройки компании',
    customers: 'Заказчики',
    customfields: 'Дополнительные поля',
    dashboard: 'Дашборд',
    days_left: '7#Заканчивается через {0} день#{0} дня#Заканчивается через {0} дней',
    featurelabs: 'Бета-функции',
    forms: 'Настраиваемые формы',
    generalOptions: 'Настройки аккаунта',
    guestPortal: 'Гостевой портал',
    integrations: 'Автоматизация',
    invoices: 'Счета',
    jobroles: 'Должности',
    logout: 'Выйти',
    mobile_apps: 'Мобильные приложения',
    myassignments: 'Мои задачи',
    myoptions: 'Мои настройки',
    mySettingsNotifications: 'Уведомления',
    mySettingsOptions: 'Расширенные настройки',
    mySettingsProfile: 'Профиль',
    myvacations: 'Мои отпуска',
    notificationCenter: 'Уведомления',
    notifications: 'Настройки уведомлений',
    payrollReport: 'Платёжная ведомость',
    portfolios: 'Портфолио',
    powerbi: 'Бизнес-аналитика',
    presetsHideViewTooltip: 'Скрыть вид',
    presetsListTitle: 'Сохраненные виды',
    projectCentricView: 'Проектно-ориентированный вид',
    ratecards: 'Карты ставок',
    recommend_us: 'Реферальная программа',
    reportgenerator: 'Нестандартные отчеты',
    reports: 'Отчеты',
    resourcesPage: 'Ресурсы',
    roles: 'Роли',
    search: 'Поиск',
    sharedProjectPlans: 'Снимки проектов',
    space: 'Настройки рабочего пространства',
    spaces: 'Рабочие пространства',
    summaryReport: 'Сводка по тайм-логам',
    support_center: 'Центр поддержки',
    support_chat: 'Чат поддержки',
    systemLists: 'Системные настройки',
    timelogs: 'Тайм-логи',
    updateLicense: 'Обновить лицензию',
    upgrade_now: 'Купить',
    users: 'Пользователи',
    vacationsreport: 'Отпуска',
    whatif: 'Моделирование загрузки ресурсов',
    workflows: 'Рабочий процесс',
};
